import { apiSlices } from '../redux/store';
import type { AppDispatch } from '../redux/store';

export const SIGNED_OUT_PATH = '/signed-out';

interface SignOutDeps {
  dispatch: AppDispatch;
  /** Writes the reset state to storage before the page unloads (the store is persisted). */
  flush: () => Promise<unknown>;
  /** A full page load, so every provider starts again from a signed-out browser. */
  redirect: (path: string) => void;
}

/**
 * Signs the browser out: the backend clears the httpOnly session cookie (JavaScript cannot), then every
 * cached API response is dropped and the person lands on the public signed-out page. Throws, leaving the
 * person signed in, when the backend call fails.
 */
export const signOut = async ({ dispatch, flush, redirect }: SignOutDeps) => {
  const res = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/dashboard-auth/logout`,
    { method: 'POST', credentials: 'include' }
  );
  if (!res.ok) throw new Error(`Sign out failed (${res.status})`);

  apiSlices.forEach((api) => dispatch(api.util.resetApiState()));
  await flush();
  sessionStorage.removeItem('redirectAfterAuth');
  sessionStorage.removeItem('loginAttempts');
  redirect(SIGNED_OUT_PATH);
};
